/**
 * Error object
 * @param {object} error - Error object
 * @param {string} errorType - Error Type
 * @returns {object} SDL object
 */
export default (error, errorType) => ({
	system: {
		error: {
			code: error.status,
			message: error.message,
			type: errorType,
			description: error.description || ''
		}
	},
	event: 'system.error'
});
